import { useMemo } from "react";
import { createTheme } from "@mui/material/styles";

// mui theme settings
export const themeSettings = () => {
  return {
    palette: {
      mode: "light",
      primary: {
        main: "#137D00",
      },
      secondary: {
        main: "#EDDDFF",
      },
      error: {
        main: "#dc3545",
      },
      neutral: {
        main: "#FFFFFF",
      },
      info: {
        main: "#CCEAE6",
      },
      background: {
        default: "#FFFFFF",
      },
    },
    typography: {
      fontFamily: ["Gilroy-Light", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Gilroy-Light", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Gilroy-Light", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Gilroy-Light", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Gilroy-Light", "sans-serif"].join(","),
        fontSize: 18,
      },
      h5: {
        fontFamily: ["Gilroy-Light", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Gilroy-Light", "sans-serif"].join(","),
        fontSize: 14,
      },
      normal: {
        fontFamily: ["Gilroy-Light", "sans-serif"].join(","),
        fontSize: 12,
      },
    },
  };
};

export const useMode = () => {
  const theme = useMemo(() => createTheme(themeSettings()), []);
  return theme;
};
